export default __webpack_public_path__ + "static/media/vidur_Twari.4681f56f.jpg";